import { handleActions } from 'redux-actions';
import { loadedApplicationList, panelsLoaded, licensesLoaded, applicationCreateFailed } from './actions';

const initialState = {
    panels: [],
    actionResult: undefined,
    licensesHeld: [],
    eligibilityErrorMessage: undefined,
};

export default handleActions(
    {
        [panelsLoaded]: (state, action) => ({
            ...state,
            ...action.payload,
        }),
        [loadedApplicationList]: (state, action) => ({
            ...state,
            actionResult: {
                ...action.payload,
            },
        }),
        [licensesLoaded]: (state, action) => {
            // eslint-disable-next-line no-console
            /*
            console.info('[TRACE][reducer]', {
                time: new Date().toISOString(),
                count: action.payload?.length,
            });
            */

            return {
                ...state,
                licensesHeld: action.payload,
            };
        },
        [applicationCreateFailed]: (state, action) => ({
            ...state,
            eligibilityErrorMessage: action.payload,
        }),
    },
    initialState,
);
